<template>
    <el-dialog
        title="请选择打印的单据"
        :visible.sync="printerShow"
        width="440px"
        class="printerDialog"
        :before-close="closeDialogOnly"
    >
        <div class="checkBox" v-loading="loading">
            <el-radio v-model="printType" label="1">配送单</el-radio>
            <el-radio v-model="printType" label="2">集配单</el-radio>
            <el-radio v-model="printType" label="3">提货单</el-radio>
            <el-radio v-model="printType" label="4">收货明细</el-radio>
            <el-radio v-model="printType" label="5">上门取件单</el-radio>
            <el-radio v-model="printType" label="6">网点派工单</el-radio>
            <el-radio v-if="this.rowData.businessMode === 'B2B'" v-model="printType" label="7">直配配送单</el-radio>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="printerConfirm">打 印</el-button>
        </div>
    </el-dialog>
</template>

<script>
import configs from '@/config/user.env';
import md5 from 'js-md5';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            loading: false,
            printerShow: false,
            rowData: {},
            printType: ''
        };
    },
    methods: {
        show(rowData) {
            this.printerShow = true;
            this.rowData = rowData;
        },
        printerConfirm() {
            if (!this.printType) return this.$message.warning('请选择打印类型');
            this.loading = true;
            let api = '';
            // 直配配送单
            if (+this.printType === 7) {
                const params = {
                    printCode: 'delivery', // 打印编码
                    tenantCode: configs.env === 'PROD' ? 'T530042416' : 'T034265737', // 租户编码
                    userCode: configs.env === 'PROD' ? 'MC640934881' : 'MC720378099', // 用户编码
                    orderNo: this.rowData.orderNo,
                    username: this.user.userName
                };
                api = this.toPrint(params);
            } else {
                api = `${process.env.VUE_APP_API_URL}/api-otp/netTask/printf?orderNo=${this.rowData.orderNo}&type=${this.printType}`;
            }
            window.open(api);
            this.loading = false;
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'printerDialog', false);
        },
        toPrint(params) {
            const fixedParams = {
                printCode: params.printCode, // 打印编码
                tenantCode: params.tenantCode, // 租户编码
                userCode: params.userCode// 用户编码
            };
            let dynamicValue = '';
            const keyAndValue = [];
            let dynamicUrl = '';
            for (const key in params) {
                if (!['printCode', 'tenantCode', 'userCode'].includes(key)) {
                    dynamicValue += params[key];
                    keyAndValue.push(key + '=' + params[key]);
                }
            }
            dynamicUrl = keyAndValue.join('&');
            const nowTime = Math.floor(new Date().getTime() / 1000);
            const EncryptionParameters = fixedParams.printCode + nowTime + fixedParams.tenantCode + fixedParams.userCode + dynamicValue;
            const token = md5(EncryptionParameters);
            const printUrl = `${configs.printUrl}T-LPAAS/logistics-paas-printer/pdf/${fixedParams.printCode}/${nowTime}/${fixedParams.tenantCode}/${fixedParams.userCode}/${token}?${dynamicUrl}`;
            return printUrl;
        }
    },
    computed: {
        ...mapState({
            user: state => state.user
        })
    }
};
</script>

<style lang="less">
.printerDialog {
    .checkBox {
        display: flex;
        width: 100%;
        flex-direction: row;
        flex-wrap: wrap;
        margin-left: 16px;
        .el-radio {
            width: 33%;
            margin: 10px 0;
            .el-radio__label {
                font-size: 14px;
            }
        }
    }
}
</style>